import { useState, useContext } from 'react'
import { useTranslation } from "react-i18next";
import { useLocation, Link, useParams } from "react-router-dom";

import { Img, Tasks, VideoPlayer } from "../components/Elements";
import { AppContext } from "../../Context";

import logo from '../assets/logo2.png';
import {  IoMdArrowDropleft } from "react-icons/io";
import { MdLocationOn, MdLocalPhone, MdPrint, MdEmail } from "react-icons/md";

import './css/footer.css'

export default function Footer() {

    const { t } = useTranslation();
    const {siteData, siteMenu, siteCats} = useContext(AppContext);
    const [siteInfo, setsiteInfo] = siteData;
    const [site_menu, setsite_menu] = siteMenu;
    const [cats, setcats] = siteCats;
    // console.log(cats);
    

    return (
        <>
        <footer>
            <div className="mainWidth">

                <nav class="links">
                    <strong>{t("links")}</strong>
                    <a  href="/"><IoMdArrowDropleft /> {t("home")}</a>
                    {site_menu?.map((v, k) => {
    
                        let selected = "";
                        let linktype = "_self";
                        if (v?.link_type?.val ) {
                            linktype = v?.data?.link_type?.val;
                        }

                        let linkData = `/cat/${v?.data?.val}`;
                        if (v?.type?.val == "contents") {
                            linkData = `/content/${v?.data?.val}`;
                        }
                        if (v?.type?.val == "link") {
                            linkData = v?.data?.link;
                        }

                        return (
                            
                                <Link key={k} target={linktype} to={linkData} ><IoMdArrowDropleft /> {v?.name}</Link>
            
                            
                        );
                        
                    })}
                    
                    {/* <a href="#"><IoMdArrowDropleft /> אודותינו</a>
                    <a href="#"><IoMdArrowDropleft /> הצוות המשפטי</a>
                    <a href="#"><IoMdArrowDropleft /> תחומי עיסוק</a>
                    <a href="#"><IoMdArrowDropleft /> צור קשר</a> */}
                </nav>

                <nav class="links">
                    <strong>תחומי עיסוק</strong>
                    {cats?.map((v, k) => {
                        
                        if (!v?.parent?.val) {
                            
                            return (
                                <Link to={`/cat/${v?._id}`} key={k}><IoMdArrowDropleft /> {v?.name}</Link>
                            );

                        }
                    })}
                   
                </nav>

                <nav style={{flex:1}}>

                </nav>

                <div class="contactBox">
                    <Img className="logo" src={siteInfo?.website?.logo[0]} load={true} /> 
                    <label><MdLocationOn /> {siteInfo?.address}</label>
                    <label><MdLocalPhone /> {siteInfo?.phone}</label>
                    {/* <label><MdPrint /> פקס 046451551</label> */}
                    <label><MdEmail /> {siteInfo?.email}</label>
                </div>

            </div>
        </footer>

        <div className="buildBy">
            Designed & developed by <a target="_blank" href="https://www.iblox.net/">Iblox</a>
        </div>
        </>
    )
}
